import { parseCellId } from '@cards/engine';
import { cardRef, defineGameCard, onAppear } from '../authoring/index.js';
export const FragmentCard = defineGameCard({
    id: 'fragment',
    gameplay: {
        type: 'UNIT', cost: 0,
        baseStats: { attack: 0, health: 1 },
    },
    presentation: {
        name: 'Фрагмент',
        description: 'Токен 0/1. Два Фрагмента в одной локации автоматически собираются в Восстановленного робота.',
        glyph: {
            colors: ['#464546', '#10213A', '#5B5C5D', '#5B5C5D', '#5B5C5D'],
            rows: [
                '....................',
                '....................',
                '....................',
                '....................',
                '....................',
                '...............11...',
                '.............11111..',
                '............231..1..',
                '..........2223......',
                '.......2223332....1.',
                '..22.2212311211..11.',
                '.23323121111221111..',
                '233231112122...11...',
                '2321111122..........',
                '23222122............',
                '211122..............',
                '.2332...............',
                '..22................',
                '....................',
                '....................',
            ],
        },
    },
    role: 'auxiliary',
    dependencies: [cardRef('fragment'), cardRef('reconstructed_robot')],
    abilities: [
        onAppear((ctx) => {
            const self = ctx.self;
            if (self?.cellId === undefined)
                return;
            const tableId = parseCellId(self.cellId).tableId;
            const pair = ctx.q.unitsOf(self.controllerId).filter((unit) => unit.defId === FragmentCard.id && unit.cellId !== undefined && parseCellId(unit.cellId).tableId === tableId).slice(0, 2);
            if (pair.length === 2) {
                ctx.ops.completeAssembly(self.controllerId, [pair[0].id, pair[1].id], ReconstructedRobotCard.id);
            }
        }),
    ],
    ui: {
        mechanics: ['token', 'fragment', 'assembly'],
        playback: {
            TokenCreated: { label: 'Создан Фрагмент', kind: 'creation' },
        },
    },
});
export const ReconstructedRobotCard = defineGameCard({
    id: 'reconstructed_robot',
    gameplay: {
        type: 'UNIT', cost: 0,
        baseStats: { attack: 3, health: 3 },
    },
    presentation: {
        name: 'Восстановленный робот',
        description: 'Токен 3/3, созданный Сборкой двух Фрагментов.',
        glyph: {
            colors: ['#10213A', '#393130', '#4E676E', '#23303A', '#74482A'],
            rows: [
                '........111.........',
                '.......23332........',
                '.......445141.......',
                '...11..415141.11....',
                '..1251.4333411221...',
                '..155134111145515...',
                '..1521323343422121..',
                '..125433523431521...',
                '..121.42221441111...',
                '..111.35522344..11..',
                '.1555.1111111..1341.',
                '.15521.4411111.1241.',
                '.1221.414.4111.121..',
                '.4334.3343213413341.',
                '.1343.44...12113341.',
                '..44.1331.13341131..',
                '.....1331.13341.1...',
                '.....4131.13441.....',
                '....13321.133241....',
                '.....1111..1111.....',
            ],
        },
    },
    role: 'auxiliary',
    ui: { mechanics: ['token', 'fragment', 'assembly'] },
});
export const ScrapCard = defineGameCard({
    id: 'scrap',
    gameplay: {
        type: 'UNIT', cost: 0,
        baseStats: { attack: 0, health: 2 }, keywords: ['CANNOT_ATTACK'],
    },
    presentation: {
        name: 'Хлам',
        description: 'Токен 0/2. Не может атаковать.',
        glyph: {
            colors: ['#10213A', '#5D3222', '#381C17', '#8B4625', '#753B23'],
            rows: [
                '....................',
                '....................',
                '......1111111.......',
                '....11122333311.....',
                '...1244322234421....',
                '....13233322331.....',
                '....12422225231..11.',
                '....12445552221.141.',
                '....12444525231.1451',
                '.1111224422533314521',
                '1445132445222132451.',
                '1314233242323133521.',
                '111431322223125111..',
                '1453313333311255551.',
                '.11114511315132521..',
                '..144541122331331...',
                '...1111.111111421...',
                '..............11....',
                '....................',
                '....................',
            ],
        },
    },
    role: 'auxiliary',
    ui: { mechanics: ['cannot_attack', 'token'] },
});
export const MicrodroneCard = defineGameCard({
    id: 'microdrone',
    gameplay: {
        type: 'UNIT', cost: 0,
        baseStats: { attack: 1, health: 1 },
    },
    presentation: {
        name: 'Микродрон',
        description: 'Токен 1/1.',
        glyph: {
            colors: ['#414251', '#10213A', '#2E2F3E', '#4D4E5D', '#222332'],
            rows: [
                '....................',
                '...................1',
                '1.2.11.........11211',
                '11311...........131.',
                '.212............211.',
                '.1232..222222..23211',
                '1.231223444452212..1',
                '...23114444141132...',
                '....221442214152....',
                '....231434434132....',
                '....231434434132....',
                '....231411114132....',
                '11..221441114152....',
                '.1.23331444415532..1',
                '.115322555555225521.',
                '.2152..222222..25432',
                '.1111...........1111',
                '.12.1.........11.2.1',
                '1...................',
                '....................',
            ],
        },
    },
    role: 'auxiliary',
    ui: { mechanics: ['token'] },
});
export const ReinforcedMicrodroneCard = defineGameCard({
    id: 'reinforced_microdrone',
    gameplay: {
        type: 'UNIT', cost: 0,
        baseStats: { attack: 4, health: 4 },
    },
    presentation: {
        name: 'Усиленный микродрон',
        description: 'Токен 4/4.',
        glyph: {
            colors: ['#10213A', '#595852', '#31373F', '#292E36', '#191C24'],
            rows: [
                '....................',
                '....................',
                '...11..........11...',
                '.112311......112311.',
                '13322331....13322331',
                '.112311......133231.',
                '...44...1111...54...',
                '..1331.133221.4441..',
                '..1445134555214441..',
                '..1445154444514441..',
                '...11112555531111...',
                '......142333451.....',
                '.....1414114341.....',
                '....15544444154.....',
                '.....15.4224.54.....',
                '........555.........',
                '....................',
                '....................',
                '....................',
                '....................',
            ],
        },
    },
    role: 'auxiliary',
    ui: { mechanics: ['token'] },
});
//# sourceMappingURL=tokens.js.map